import {z} from 'zod'
import {ReferringSpecialistTitle} from './types'

export const CreateUpdateReferringSpecialistValidationSchema = z.object({
    title: z.enum(ReferringSpecialistTitle.options, {required_error: 'commons:required_field'}),
    firstName: z.string().min(1, {message: 'commons:required_field'}).trim(),
    lastName: z.string().min(1, {message: 'commons:required_field'}).trim(),
    serviceUoc: z.string().min(1, {message: 'commons:required_field'}).trim(),
    email: z.string().email({message: 'commons:invalid_email'}).trim()
})
export type CreateUpdateReferringSpecialistValidationSchemaType = z.infer<
    typeof CreateUpdateReferringSpecialistValidationSchema
>
